/**
 * @description Permissions
 * @param role
 */

const permissions = {
  'doorlock.install': 'Door lock Setup',
  'doorlock.log': 'Door lock LOG',
  'doorlock.master': 'Master Mobilekey',
  'doorlock.staff': 'Staff Mobilekey',
  'guestcard.issue': 'ISSUE CARD',
  'hotel.config': 'Room Setting',
  'log.list': 'Card History',
  'staff.config': 'Staff Management',
};

export default {
  getRoleString(role) {
    return permissions[role] || `Unknown(${role})`;
  },
};



// WEBPACK FOOTER //
// ./src/permissions/index.js